import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Organization } from 'apps/marsinet/src/app/typescript-axios';
import OrganizationMultiselect from '../organization-multiselect/organization-multiselect';

interface RecipientsDialogProps {
  visible: boolean;
  onHide: () => void;
  organizations: Organization[];
  selectedOrganizations: string[];
  onSelectionChange: (selectedIds: string[]) => void;
  onConfirm: () => void;
  dialogType: 'add' | 'delete';
}

const RecipientsDialog: React.FC<RecipientsDialogProps> = ({
  visible,
  onHide,
  organizations,
  selectedOrganizations,
  onSelectionChange,
  onConfirm,
  dialogType,
}) => {
  const { t } = useTranslation();

  const isAddMode = dialogType === 'add';
  const headerKey = isAddMode
    ? 'pages.surveys.add_recipients'
    : 'pages.surveys.delete_recipients';
  const buttonKey = isAddMode
    ? 'pages.surveys.add_recipients'
    : 'pages.surveys.delete_recipients';

  return (
    <Dialog
      header={t(headerKey)}
      visible={visible}
      onHide={onHide}
      style={{ width: '50vw' }}
      breakpoints={{ '960px': '75vw', '641px': '100vw' }}
    >
      <div className="grid formgrid p-fluid">
        <div className="field col-12">
          <label className="font-bold mb-3 block">
            {t('pages.surveys.select_organizations')}
          </label>
          <OrganizationMultiselect
            organizations={organizations}
            value={selectedOrganizations}
            onChange={onSelectionChange}
            placeholder={t('pages.surveys.select_organizations')}
            maxSelectedLabels={3}
            className="w-full"
          />
        </div>
        <div className="field col-12 flex justify-content-end gap-2">
          <Button
            label={t('cancel')}
            icon="pi pi-times"
            onClick={onHide}
            className="p-button-text"
          />
          <Button
            label={t(buttonKey)}
            icon={isAddMode ? 'pi pi-check' : 'pi pi-trash'}
            onClick={onConfirm}
            disabled={selectedOrganizations.length === 0}
            severity={isAddMode ? 'secondary' : 'danger'}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default RecipientsDialog;
